function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => React.createElement("svg", _extends({
  viewBox: "0 0 512 512"
}, props), React.createElement("path", {
  d: "M272 32c9 0 16 7 16 16v32c0 9-7 16-16 16h-48v32h272c9 0 16 7 16 16v224c0 9-7 16-16 16H224v32h48c9 0 16 7 16 16v32c0 9-7 16-16 16H112c-9 0-16-7-16-16v-32c0-9 7-16 16-16h48V96h-48c-9 0-16-7-16-16V48c0-9 7-16 16-16zm-48 288h224V192H224zm64-96c18 0 32 14 32 32s-14 32-32 32-32-14-32-32 14-32 32-32zm96 0c18 0 32 14 32 32s-14 32-32 32-32-14-32-32 14-32 32-32zM96 128v64H64v128h32v64H16c-9 0-16-7-16-16V144c0-9 7-16 16-16z"
})));